import type { KBDataPointDef, KBEquipmentDefinition } from "@/lib/api/building";

/** One dropdown section of candidate KB data points. `label` is a component name
 *  for equipment (grouped); `null` renders a flat, ungrouped list (zones have no
 *  component grouping — see docs/spec/concepts.md § Equipment signal
 *  CSV upload). */
export interface RemapCandidateGroup {
  label: string | null;
  dataPoints: KBDataPointDef[];
}

/** Shared by both equipment import surfaces (Syötä dataa dialog, equipment-detail
 *  upload modal) so component grouping stays identical between them. */
export function equipmentCandidateGroups(
  def: KBEquipmentDefinition,
): RemapCandidateGroup[] {
  const groups: RemapCandidateGroup[] = def.components
    .filter((c) => c.data_points.length > 0)
    .map((c) => ({ label: c.name_fi, dataPoints: c.data_points }));
  if (def.shared_data_points.length > 0) {
    groups.push({ label: "Yhteiset", dataPoints: def.shared_data_points });
  }
  return groups;
}
